import DataTable, { TableColumn } from "react-data-table-component";
import { NoResult } from "../Common/NoResult";
import "../../styles/dashboard.css";
import { Button, Modal, ModalHeader, Table } from "reactstrap";
import { jumpTo } from "../UrlModal";
import { useState } from "react";
import moment from "moment";
import Loader from "../Common/Loader";
import { fetchTopPlanDetail } from "../../api/market";
import { KWHPriceChart } from "../KWHPriceChart";
import { getKWHPrice } from "../../store/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Tooltip } from '@mui/material';

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#F2F2F2",
      paddingRight: 0,
    },
  },
};

const TxDataTable = ({
  data,
  isHide,
  planType,
}: {
  data: any;
  isHide: boolean;
  planType?: number | null;
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const goToPlanInsight = (plan: any, kwh: string, row: any) => {
    if (!plan) return;
    const params = new URLSearchParams();
    if (row?.utility_id) params.set("utility_id", String(row.utility_id));
    if (plan.created_ts) params.set("created_ts", plan.created_ts);
    if (kwh) params.set("usage", kwh);
    if (plan.contract_term != null) params.set("term", String(plan.contract_term));
    if (plan.provider_id != null) params.set("provider_id", String(plan.provider_id));
    if (plan.source) params.set("source", String(plan.source));
    const effectivePlanType =
      planType !== undefined &&
      planType !== null &&
      Number(planType) !== 0
        ? Number(planType)
        : plan.plan_type != null && plan.plan_type !== ""
        ? plan.plan_type
        : undefined;
    if (
      effectivePlanType !== undefined &&
      effectivePlanType !== null &&
      effectivePlanType !== ""
    ) {
      params.set("plan_type", String(effectivePlanType));
    }
    history.push(`/plan-insight?${params.toString()}`);
  };
  const [isShowDetail, setIsShowDetail] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [planDetail, setPlanDetail] = useState<any>(undefined);

  const formattedData: any = [];

  data.forEach((entry: any) => {
    const utilityName = entry.utility_name;
    const priceData = entry.price_data;
    for (const [key, value] of Object.entries(priceData)) {
      if (typeof value === "object" && value !== null) {
        formattedData.push({
          ...value,
          utility_name: utilityName,
          utility_id: entry.utility_id,
          kwh: key.replace(/\D/g, ""),
        });
      }
    }
  });

  const filteredData = isHide
    ? formattedData.filter(
        (item: any) =>
          item.market_rank !== 0 || JSON.stringify(item.your_plan) !== "[]"
      )
    : formattedData;

  const showDetail = (planId: string, price: string, createdTs: string) => {
    setIsShowDetail(true);
    setLoadingDetail(true);
    dispatch(getKWHPrice(true));

    fetchTopPlanDetail(
      planId,
      price,
      createdTs,
      `${moment().subtract(1, "months").format("YYYY-MM-DD")}&${moment().format(
        "YYYY-MM-DD"
      )}`
    ).then((res) => {
      setLoadingDetail(false);
      if (res && parseInt(res.status) === 1) {
        const { response } = res || {};

        let series: any[] = [];

        response?.rank_trend?.forEach((item: any) => {
          if (item?.rank !== 0) {
            series.push({ x: item.date, y: item.rank });
          } else {
            series.push({ x: item.date, y: null });
          }
        });

        setPlanDetail({
          chartData: [{ id: "Rank", data: series.filter((i: any) => i.y) }],
          planInfo: response?.plan,
        });
      }
    });
  };

  const closeDetail = () => {
    setPlanDetail(undefined);
    setIsShowDetail(false);
    dispatch(getKWHPrice(false));
  };

  const goToPlanInsightByProviderCount = (row: any) => {
    const dummyPlan = {
      contract_term: null,
      provider_id: null,
      source: null,
      created_ts: undefined,
      plan_type: null,
    };
    goToPlanInsight(dummyPlan, row?.kwh, row);
  };

  const columns: TableColumn<any>[] = [
    {
      name: <span className="font-weight-bold fs-14">Utility</span>,
      selector: (row: any) => row.utility_name,
      width: "200px",
    },
    {
      name: <span className="font-weight-bold fs-14">Monthly kWh Usage</span>,
      selector: (row: any) => `${row.kwh} kWh`,
    },
    {
      name: <span className="font-weight-bold fs-14">Provider Count</span>,
      selector: (row: any) => row.provider_count,
      cell: (row: any) => (
        <button
          type="button"
          className="btn btn-link p-0 tx-dashboard-table-link"
          onClick={() => goToPlanInsightByProviderCount(row)}
        >
          {row.provider_count}
        </button>
      ),
    },
    {
      name: <span className="font-weight-bold fs-14">Market Plan Count (MKT) / My Plan Count (MY)</span>,
      selector: (row: any) => (
        <table>
          <tbody>
            <tr>
              <td width="35">MKT</td>
              <td>{row.plan_count}</td>
            </tr>
            <tr>
              <td width="35">MY</td>
              <td>{row.your_plan_count || "-"}</td>
            </tr>
          </tbody>
        </table>
      ),
      width: "150px",
    },
    {
      name: (
        <span className="font-weight-bold fs-14">
          Market Average Rate (MKT) / Lowest Rate (LST) / My Rate (MY)
        </span>
      ),
      selector: (row: any) => {
        // const getBarColor = (rank: string) => {
        //   if (Number(rank) >= 0 && Number(rank) <= 10) return "low";
        //   if (Number(rank) >= 11 && Number(rank) <= 20) return "mid";
        //   return "high";
        // };

        const maxValue = Math.max(
          Number(row.average_rate),
          Number(row.lowest_rate),
          Number(row.your_rate)
        );

        return (
          <table width="250">
            <tbody>
              <tr>
                <td width="35">AVG</td>
                <td width="65">{row.average_rate}¢</td>
                <td>
                  <div
                    className={`price-bar`}
                    style={{
                      width: (Number(row.average_rate) / maxValue) * 100,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td width="35">LST</td>
                <td width="65">{row.lowest_rate}¢</td>
                <td>
                  <div
                    className={`price-bar`}
                    style={{
                      width: (Number(row.lowest_rate) / maxValue) * 100,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td width="35">MY</td>
                <td width="65">{row.your_rate ? `${row.your_rate}¢` : "-"}</td>
                <td>
                  <div
                    className={`price-bar`}
                    style={{ width: (Number(row.your_rate) / maxValue) * 100 }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        );
      },
      width: "250px",
    },
    {
        name: (
          <div className="d-flex align-items-center">
            <Tooltip title={
                <div>
                    <div className="fs-12 d-flex align-items-center mb-2" style={{fontFamily: "'Rubik', sans-serif", fontWeight:'400'}}><span style={{ backgroundColor: '#54934A', borderRadius: '50%', display: 'inline-block', width: '14px', height: '14px', marginRight: '5px' }}></span>Highly competitive (0-10)</div>
                    <div className="fs-12 d-flex align-items-center mb-2" style={{fontFamily: "'Rubik', sans-serif", fontWeight:'400'}}><span style={{ backgroundColor: '#F0CB3D', borderRadius: '50%', display: 'inline-block', width: '14px', height: '14px', marginRight: '5px' }}></span>Moderately competitive (11-20)</div>
                    <div className="fs-12 d-flex align-items-center" style={{fontFamily: "'Rubik', sans-serif", fontWeight:'400'}}><span style={{ backgroundColor: '#D05050', borderRadius: '50%', display: 'inline-block', width: '14px', height: '14px', marginRight: '5px' }}></span>Not competitive (21 and above)</div>
                </div>
            }>
                <img src="/img/icon_tips.png" height={14} className="me-1" alt="" />
            </Tooltip>
            <span className="font-weight-bold fs-14">Market Rank</span>
          </div>

        ),
        selector: (row: any) => {
          const getBarColor = (rank: string) => {
            if (Number(rank) >= 0 && Number(rank) <= 10) return "#54934A";
            if (Number(rank) >= 11 && Number(rank) <= 20) return "#F0CB3D";
            return "#D05050";
          };
          
          const rank = row.market_rank || "-";
          if (rank === "-") {
            return "-";
          }
          
          return (
            <div className="d-flex align-items-center">
              <span 
                style={{ 
                  backgroundColor: getBarColor(row.market_rank), 
                  borderRadius: '50%', 
                  display: 'inline-block', 
                  width: '10px', 
                  height: '10px', 
                  marginRight: '5px' 
                }}
              ></span>
              {rank}
            </div>
          );
        },
        width:'120px'
    },
    {
      name: <span className="font-weight-bold fs-14">Lowest Rate Plan</span>,
      selector: (row: any) => {
        if (row?.rank1_plan && JSON.stringify(row?.rank1_plan) !== "[]") {
          return (
            <div className="py-2">
              <div>
                <button
                  type="button"
                  className="btn btn-link p-0 font-weight-medium tx-dashboard-table-link"
                  onClick={() => goToPlanInsight(row?.rank1_plan, row?.kwh, row)}
                >
                  {row?.rank1_plan?.provider_name}
                </button>
              </div>
              <div
                className="text-muted fs-12 mb-1"
                style={{ whiteSpace: "normal" }}
              >
                {row?.rank1_plan?.plan_name}
              </div>
              <div>
                Term {row?.rank1_plan?.contract_term}{" "}
                <span className="text-muted ms-1 me-1 fs-12">|</span>{" "}
                {row?.rank1_plan?.price}¢
              </div>
              <div className="d-flex gap-2 mt-2">
                <Button
                  color="secondary"
                  outline
                  className="btn btn-sm"
                  onClick={() =>
                    showDetail(
                      row?.rank1_plan?.plan_id,
                      row?.kwh,
                      row?.rank1_plan?.created_ts
                    )
                  }
                >
                  Snapshot
                </Button>
                <Button
                  onClick={() => {
                    jumpTo(row?.rank1_plan?.plan_id, row?.rank1_plan?.pd_id);
                  }}
                  outline
                  className="btn btn-sm"
                >
                  EFL
                </Button>
              </div>
            </div>
          );
        } else {
          return <div className="no-plan-col">No Plan</div>;
        }
      },
      width: "250px",
    },
    {
      name: <span className="font-weight-bold fs-14">My Plan</span>,
      selector: (row: any) => {
        if (row?.your_plan && JSON.stringify(row?.your_plan) !== "[]") {
          return (
            <div className="py-2">
              <div>
                <button
                  type="button"
                  className="btn btn-link p-0 font-weight-medium tx-dashboard-table-link"
                  onClick={() => goToPlanInsight(row?.your_plan, row?.kwh, row)}
                >
                  {row?.your_plan?.provider_name}
                </button>
              </div>
              <div
                className="text-muted fs-12 mb-1"
                style={{ whiteSpace: "normal" }}
              >
                {row?.your_plan?.plan_name}
              </div>
              <div>
                Term {row?.your_plan?.contract_term}{" "}
                <span className="text-muted ms-1 me-1 fs-12">|</span>{" "}
                {row?.your_plan?.price}¢
              </div>
              <div className="d-flex gap-2 mt-2">
                <Button
                  color="secondary"
                  outline
                  className="btn btn-sm"
                  onClick={() =>
                    showDetail(
                      row?.your_plan?.plan_id,
                      row?.kwh,
                      row?.your_plan?.created_ts
                    )
                  }
                >
                  Snapshot
                </Button>
                <Button
                  onClick={() => {
                    jumpTo(row?.your_plan?.plan_id, row?.your_plan?.pd_id);
                  }}
                  outline
                  className="btn btn-sm"
                >
                  EFL
                </Button>
              </div>
            </div>
          );
        } else {
          return <div className="no-plan-col">No Plan</div>;
        }
      },
      width: "250px",
    },
  ];

  return (
    <>
      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          paginationPerPage={10}
          customStyles={customStyles}
          pagination={false}
        />
      ) : (
        <NoResult />
      )}
      <Modal size="lg" isOpen={isShowDetail} toggle={closeDetail} centered>
        <ModalHeader toggle={closeDetail}>
          My Plan Detail
          <span className="fs-14 text-muted ms-3">
            {`${moment()
              .subtract(1, "months")
              .format("YYYY-MM-DD")} - ${moment().format("YYYY-MM-DD")}`}
          </span>
        </ModalHeader>
        {loadingDetail ? (
          <Loader />
        ) : planDetail ? (
          <div className="modal-body" style={{ overflow: "hidden" }}>
            <>
              <Table className="align-middle table-fixed mb-0">
                <thead>
                  <tr>
                    <th scope="col">REP Name</th>
                    <th scope="col">TDU Name</th>
                    <th scope="col">Term</th>
                    <th scope="col">Base Rate</th>
                    <th scope="col">Plan Source</th>
                    <th scope="col">Cancellation Fee</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{planDetail.planInfo.provider_name}</td>
                    <td>{planDetail.planInfo.utility_name}</td>
                    <td>{planDetail.planInfo.contract_term}</td>
                    <td>
                      {planDetail.planInfo.base_rate}
                      {planDetail.planInfo.base_rate ? "¢" : ""}
                    </td>
                    <td>{planDetail.planInfo.source || ""}</td>
                    <td>{planDetail.planInfo.cancel_fee}</td>
                  </tr>
                </tbody>
              </Table>
            </>
          </div>
        ) : (
          <NoResult />
        )}
        {planDetail?.planInfo && (
          <KWHPriceChart
            plan_id={planDetail.planInfo.plan_id}
            pd_id={planDetail.planInfo.pd_id}
          />
        )}
      </Modal>
    </>
  );
};

export default TxDataTable;
